import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = React.useState(false);

  const languages = [
    { code: 'en', label: 'English' },
    { code: 'ru', label: 'Русский' },
    { code: 'kz', label: 'Қазақша' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    
    // Update URL based on language
    let newPath = location.pathname;
    
    // Remove existing language suffix from path segments
    newPath = newPath.replace(/-ru(\/|$)/g, '$1').replace(/-kz(\/|$)/g, '$1');
    
    // Homepage special case - don't add suffix
    if (newPath === '/' || newPath === '') {
      // Stay on homepage, just change language
      setIsOpen(false);
      return;
    }
    
    // Handle paths with parameters (e.g., /customize/:id or /confirmation/:id)
    const pathParts = newPath.split('/');
    if (pathParts.length > 1 && pathParts[1]) {
      // Add language suffix to the route name, not the parameter
      if (langCode === 'ru') {
        pathParts[1] = `${pathParts[1]}-ru`;
      } else if (langCode === 'kz') {
        pathParts[1] = `${pathParts[1]}-kz`;
      }
      newPath = pathParts.join('/');
    }
    
    navigate(newPath + location.search);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 text-gray-700 hover:text-[#1E88E5] transition-colors rounded-lg hover:bg-gray-100"
      >
        <Globe className="w-4 h-4" />
        <span className="font-medium">{currentLanguage.code.toUpperCase()}</span>
        <svg className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`w-full px-4 py-2 text-left flex items-center space-x-3 hover:bg-gray-100 transition-colors ${
                i18n.language === lang.code ? 'bg-blue-50 text-[#1E88E5]' : 'text-gray-700'
              }`}
            >
              <span className="font-medium">{lang.label}</span>
              {i18n.language === lang.code && (
                <svg className="w-4 h-4 ml-auto" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
